import clsx from "clsx";
import { Col, Form, Pagination, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import React from "react";
import _ from "lodash";
import EmptyItemView from "../../../../components/EmptyItemView";
import constants from "../../../../constants";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import * as paymentSelectors from "../../../../selectors/payment";
import {getPaymentDetailAdditionalCharges, getPaymentDetailCreatedAtDateTimeText} from "../../../../selectors/payment";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";
import * as setOffSelectors from "../../../../selectors/set-off";

const PaymentHistoryTable = ({
  data,
  page,
  setPage,
  onClickViewPayment,
  statusOptions,
  onChangeStatus,
  statusFilter,
  onChangeDateFrom,
  dateTo,
  dateFrom,
  onChangeDateTo, onClickDeleteFunction, loading
}) => {
  const datalisting = _.get(data, ["data", "data"], []);
  const lastPage = _.get(data, ["data", "meta", "last_page"], null);
  const isLoading = _.get(data,['isLoading'],false)
  const onClickView = (id) => {
    onClickViewPayment(id);
  };
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  const onClickDelete = (url) => {
    onClickDeleteFunction(url);
  };

  return (
    <div className=" pb-3">
      <div className={clsx("custom-table-info-container padding-12px mt-4")}>
        <Row>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Status</Form.Label>
              <Form.Select
                className="formControl"
                style={{ height: "100%" }}
                onChange={onChangeStatus}
                value={statusFilter}
              >
                <option value={null}>All</option>
                {_.map(statusOptions, (item, index) => (
                  <option key={index} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Date From</Form.Label>
              <Form.Control
                min="2025-04-01"
                max={dateNow}
                onChange={onChangeDateFrom}
                value={dateFrom}
                className="formControl"
                name="date_from"
                type="date"
              />
            </Form.Group>
          </Col>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Date To</Form.Label>
              <Form.Control
                max={dateNow}
                min={dateFrom}
                onChange={onChangeDateTo}
                value={dateTo}
                className="formControl"
                name="date_to"
                type="date"
              />
            </Form.Group>
          </Col>
        </Row>
        <div className={"responsive-table-border table-w-1400 mt-3"}>
          <Table responsive="lg">
            <thead>
            <tr className={"custom-table-setoff-styled"}>
              <th style={{minWidth: 100}}>Date/Time</th>
              <th style={{minWidth: 100}}>Type</th>
              <th style={{minWidth: 250}}>Reference Number</th>
              <th style={{minWidth: 120}}>Deposit Amount</th>
              <th style={{minWidth: 120}}>Payment Amount</th>
              <th style={{minWidth: 120}}>Total Amount</th>
              <th style={{minWidth: 150}}>Remarks</th>
              <th style={{minWidth: 100}}>Status</th>
              <th style={{minWidth: 150}}>Action</th>
            </tr>
            </thead>
            <tbody>
            {!_.isEmpty(datalisting) && !isLoading ? (
                _.map(datalisting, (item, index) => {
                  const type = paymentSelectors.getPaymentDetailTypeText(item);
                  const reference = paymentSelectors.getPaymentDetailReference(item);
                  const depositAmount = paymentSelectors.getPaymentDetailDepositAmountFullText(item);
                  const paymentAmount = paymentSelectors.getPaymentDetailPaymentAmountFullText(item);
                  const totalAmount = paymentSelectors.getPaymentDetailTotalFullText(item);
                  const clientRemarks = paymentSelectors.getPaymentDetailClientRemarks(item);
                  const status = paymentSelectors.getPaymentDetailStatusText(item);
                  const statusValue = paymentSelectors.getPaymentDetailStatusValue(item);
                  const id = paymentSelectors.getPaymentDetailID(item);
                  const clientCode = paymentSelectors.getPaymentDetailClientCode(item);
                  const createdAt = paymentSelectors.getPaymentDetailCreatedAtDateTimeText(item);
                  const additionalCharges = paymentSelectors.getPaymentDetailAdditionalCharges(item);
                  const isCancellable = setOffSelectors.getSubmittedContractIsCancellable(item);
                  const cancelLink = setOffSelectors.getSubmittedContractCancelLink(item);

                  // Status color turnover
                  return (
                    <tr key={index}>
                      <td>{createdAt}</td>
                      <td>{type}</td>
                      <td style={{ overflowWrap: "break-word" }}>{reference}</td>
                      <td>{depositAmount}</td>
                      <td>{paymentAmount}</td>
                      <td>{totalAmount}</td>
                      <td>
                        <CustomEmptyFont value={clientRemarks} variant="span" />
                      </td>
                      <td>
                        <span
                          className={clsx("status-span ", {
                            ["pending-color"]: _.isEqual(constants.STATUS_PAYMENT_PENDING, statusValue),
                            ["successful-color"]:
                              _.isEqual(constants.STATUS_PAYMENT_PAYMENT_MADE, statusValue) ||
                              _.isEqual(constants.STATUS_PAYMENT_APPROVED, statusValue),
                            ["error-color"]:
                              _.isEqual(constants.STATUS_PAYMENT_CANCELLED, statusValue) ||
                              _.isEqual(constants.STATUS_PAYMENT_ERROR, statusValue) ||
                              _.isEqual(constants.STATUS_PAYMENT_REJECTED, statusValue),
                          })}
                        >
                          {status}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex">
                          <button
                            className={clsx("btn custom-button-grey me-2")}
                            onClick={() => onClickView(id)}
                          >
                            View
                          </button>
                          {isCancellable ? (
                              <button
                                  className={clsx("btn custom-button-white small long mx-2")}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onClickDelete(cancelLink)
                                  }}
                                  disabled={!isCancellable}
                              >
                                Cancel
                              </button>
                          ) : ( false )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={9}>
                    <EmptyItemView />
                    <LoadingOverlay loading={isLoading}></LoadingOverlay>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="epayment-table-footer">
              <tr>
                <td colSpan={10}>
                  {lastPage > 1 ? (
                    <div className={clsx("d-flex justify-content-center")}>
                      <Pagination
                        className="mt-2"
                        onClick={(e) => {
                          if (_.toInteger(e.target.text) !== 0 && _.toInteger(e.target.text) !== page) {
                            setPage(_.toInteger(e.target.text));
                          }
                        }}
                      >
                        {_.times(lastPage, (index) => {
                          return (
                            <Pagination.Item key={index + 1} active={page === index + 1}>
                              {index + 1}
                            </Pagination.Item>
                          );
                        })}
                      </Pagination>
                    </div>
                  ) : (
                    false
                  )}
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </div>
      <LoadingOverlay loading={loading}></LoadingOverlay>
    </div>
  );
};

export default PaymentHistoryTable;
